module.exports = __webpack_public_path__ + "img/2.6ad26693.png";